import type { BaseModel } from './common.types';
import type { MediaData } from './medias.types';
import type { UserModel } from './users.types';
import type { VisitModel } from './visits.types';
import type { VisitFaultModel } from './visits-faults.types';

export enum CommentType {
  VisitCommon = 'Visit common',
  VisitFuture = 'Visit future',
  VisitLast = 'Visit last',
  PreClean = 'Pre clean',
  PreCleanClient = 'Pre clean client',
  Wastage = 'Wastage',
  Temperature = 'Temperature',
  Hygiene = 'Hygiene',
  BestPractice = 'Best practice',
  GlassWasher = 'Glass Washer',
  FaultClientResolution = 'Fault Client Resolution',
  FaultAdminResolution = 'Fault Admin Resolution',
  FaultClientPostResolution = 'Fault Client Post Resolution'
}

export interface CommentModel extends BaseModel {
  content: string;
  type: CommentType;
  subType?: string;
  customSubType?: string;
  interviewedName?: string;
  author?: UserModel;
  authorName?: string;
  visit?: VisitModel;
  fault?: VisitFaultModel;
  medias?: MediaData[];
}

export interface ExtendedCommentModel extends CommentModel {
  authorId: string;
  faultId?: string;
}

export type CommentParams = Omit<CommentModel, 'author' | 'visit'> & {
  authorId?: string;
  faultId?: string;
};

export type BestPracticeComment = CommentModel & {
  staticContent: string | undefined;
};

export enum BestPracticeType {
  CellarManagement = 'Cellar Management',
  BackboardHygiene = 'Backboard Hygiene',
  CouplerHygiene = 'Coupler Hygiene',
  KegChange = 'Keg Change',
  CaskProcess = 'Cask Process',
  AirflowMaintenance = 'Airflow Maintenance',
  BarManagement = 'Bar Management',
  Glassware = 'Glassware',
  GlassWasherMaintenance = 'Glass Washer Maintenance',
  NozzleHygiene = 'Nozzle Hygiene',
  PourTechnique = 'Pour Technique',
  GasManagement = 'Gas Management',
  EcoEfficiency = 'Eco Efficiency',
  Other = 'Other'
}
